export default __webpack_public_path__ + "images/blog6.jpg";